import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import IbChart from "../component/IbChart";
import { useEffect, useState, useCallback, useRef } from "react";
import CommonTable from "../component/CommonTable";
import { useHandleError } from "../hooks/useHandleError";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import MessageToster from "../component/MessageToster";
import Loader from "../component/Loader";
import useIbStatus from "../hooks/useIbStatus";

export default function IbDashboard() {
  const handleError = useHandleError();
  const isFetchingRef = useRef(false);

  const [ibCommissionData, setIbCommissionData] = useState(() => {
    try {
      const cached = sessionStorage.getItem("ib_commission_dashboard_summary");
      return cached ? JSON.parse(cached) : {};
    } catch {
      return {};
    }
  });
  const [loading, setLoading] = useState(false);

  const {
    ibStatus,
    ibLoading,
    isPending,
    isNotApplied
  } = useIbStatus();

  const isPageLoading = ibLoading || loading;

  const getIbCommissionData = useCallback(async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/IB/ib_commission_dashboard_data`, {
        headers: getApiHeaders(),
      });

      let resData = res?.data;
      if (typeof resData === "string") {
        try {
          resData = JSON.parse(resData);
        } catch {
          // ignore
        }
      }

      if (
        resData?.code === 200 ||
        resData?.code === "200" ||
        resData?.status === "success" ||
        resData?.msgcode === "Success"
      ) {
        let raw = resData?.data;
        if (typeof raw === "string") {
          try {
            raw = JSON.parse(raw);
          } catch {
            // ignore
          }
        }

        const item = Array.isArray(raw) ? raw[0] : (raw && typeof raw === "object" ? raw : null);
        if (item) {
          setIbCommissionData(item);
          try {
            sessionStorage.setItem("ib_commission_dashboard_summary", JSON.stringify(item));
          } catch {
            // ignore
          }
        }
      } else {
        MessageToster("error", resData?.message || "Something went wrong");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  }, [handleError]);

  useEffect(() => {
    getIbCommissionData();
  }, [getIbCommissionData]);


  return (
    <>
      <div id="layout-wrapper">
        {isPageLoading && <Loader />}
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            {isPending && (
              <>
                <div className="row justify-content-center">
                  <div
                    className="alert alert-warning alert-dismissible fade show"
                    role="alert"
                    style={{
                      backgroundColor: "#fff3cd",
                      borderColor: "#ffeeba",
                      color: "#856404",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <i className="mdi mdi-timer-sand-full me-2" />
                    Your IB Account application status is <strong>pending</strong>. Please
                    allow up to 24 hours for verification and approval.
                  </div>
                </div>
              </>
            )}

            {isNotApplied && (
              <>
                <div className="row justify-content-center">
                  <div
                    className="alert alert-warning alert-dismissible fade show"
                    role="alert"
                    style={{
                      backgroundColor: "#fff3cd",
                      borderColor: "#ffeeba",
                      color: "#856404",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <i className="mdi mdi-timer-sand-full me-2" />
                    You have <strong>not applied</strong> for an IB Account yet.
                    Please submit your IB application to get started.
                  </div>
                </div>
              </>
            )}

            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">IB Dashboard</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row">
                <div className="col-xl-12">
                  <div className="row">
                    {/* <div className="col-xl-4 col-lg-6 col-sm-6"> */}
                    {/* 1) Total Commission */}
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-orange-subtle">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Total Commission
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.total_commission !== undefined
                                  ? Number(ibCommissionData.total_commission).toFixed(2)
                                  : "0.00"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded bg_volume">
                                  <i className="bx bxs-bar-chart-square font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Withdrawn Commission - Commented as requested */}
                    {/*
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-gray-subtle">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Withdrawn Commission
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.withdraw_commission?.toFixed(2) || "0"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded withdraw_icon_bg">
                                  <i className="bx bxs-bookmark font-size-24">
                                    <i className="bx bx-percent" />
                                  </i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    */}

                    {/* Available Commission - Commented as requested */}
                    {/*
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-pink-subtle">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Available Commission
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.available_commission?.toFixed(2) || "0"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded bg_mission">
                                  <i className="bx bx-copy-alt font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    */}

                    {/* 2) Total Volume */}
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-orange-subtle">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Total Volume
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.total_volume !== undefined
                                  ? ibCommissionData.total_volume
                                  : "0"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded bg_volume">
                                  <i className="bx bxs-bar-chart-square font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 3) Total Reffers */}
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-primary-subtle">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Total Reffers
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.total_referral !== undefined
                                  ? ibCommissionData.total_referral
                                  : "0"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded">
                                  <i className="bx bx-user-check font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 4) Active Clients */}
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-sky-subtle">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Active Clients
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.total_client_created_accounts !== undefined
                                  ? ibCommissionData.total_client_created_accounts
                                  : "0"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded bg_clients">
                                  <i className="bx bx-user-plus font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 5) MT5 Total Account */}
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-danger-subtle ib_withdrawn">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                MT5 Total Account
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.total_client_accounts !== undefined
                                  ? ibCommissionData.total_client_accounts
                                  : "0"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded bg-danger">
                                  <i className="bx bx-user-plus font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 6) Active IB */}
                    <div className="col-xxl-4 col-xl-4 col-lg-6 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-primary-subtle">
                        <div className="card-body upcoming-box p-3">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Active IB
                              </h5>
                              <h2 className="mb-0">
                                {ibCommissionData?.total_ib_accounts !== undefined
                                  ? ibCommissionData.total_ib_accounts
                                  : "0"}
                              </h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded">
                                  <i className="bx bx-user-check font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-xl-4">
                  <div className="row">
                    <div className="col-xl-12 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-danger-subtle ib_withdrawn">
                        <div className="card-body upcoming-box p-4">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">
                                Active Traders
                              </h5>
                              <h2 className="mb-0">{ibClientData?.total_client_created_accounts}</h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded bg-danger">
                                  <i className="bx bx-user-plus font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12 col-sm-6">
                      <div className="card core-teams-card overflow-hidden bg-primary-subtle">
                        <div className="card-body upcoming-box p-4">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="text-muted fw-medium">Active IB</h5>
                              <h2 className="mb-0">{ibClientData?.total_ib_accounts}</h2>
                            </div>
                            <div className="flex-shrink-0 align-self-center">
                              <div className="avatar-sm upcoming-icon">
                                <span className="avatar-title rounded">
                                  <i className="bx bx-user-check font-size-24" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="col-xxl-4 col-xl-12 col-lg-12">
                  <div className="card">
                    <div className="card-body p-3">
                      <div>
                        <CommonTable
                          hideHeader={true}
                          columns={[
                            {
                              accessor: "icon",
                              render: (row) => (
                                <>
                                  <div className="avatar-xs d-sm-none">
                                    <div className={`avatar-title ${row.iconBgClass} rounded-circle text-danger`}>
                                      <i className={`bx ${row.iconClass} text-light fs-6`} />
                                    </div>
                                  </div>
                                  <div className="avatar-sm d-none d-sm-block">
                                    <div className={`avatar-title ${row.iconBgClass} rounded-circle text-danger font-size-20`}>
                                      <i className={`bx ${row.iconClass} text-light font-size-20`} />
                                    </div>
                                  </div>
                                </>
                              )
                            },
                            {
                              accessor: "title",
                              render: (row) => (
                                <>
                                  <h5 className="m-0 text-wrap d-sm-none" style={{ fontSize: '12px', minWidth: '95px', lineHeight: '1.2' }}>
                                    <span className="text-dark">
                                      {row.title}
                                    </span>
                                  </h5>
                                  <h5 className="font-size-14 m-0 text-wrap d-none d-sm-block" style={{ minWidth: "120px" }}>
                                    <span className="text-dark">
                                      {row.title}
                                    </span>
                                  </h5>
                                </>
                              )
                            },
                            {
                              accessor: "value",
                              render: (row) => (
                                <div className="text-end">
                                  <h4 className="mb-0 fs-6 d-sm-none">{row.value}</h4>
                                  <h4 className="mb-0 fs-5 d-none d-sm-block">{row.value}</h4>
                                </div>
                              )
                            }
                          ]}
                          data={[
                            {
                              title: "KYC Documents",
                              value: "0",
                              iconClass: "bx-file-find",
                              iconBgClass: "bg-info"
                            },
                            {
                              title: "MT5 Live Accounts",
                              value: "0",
                              iconClass: "bx-bar-chart-alt-2",
                              iconBgClass: "bg-success"
                            },
                            {
                              title: "First Trading Deposit",
                              value: "0",
                              iconClass: "bx-dollar-circle",
                              iconBgClass: "bg-danger"
                            },
                            {
                              title: "IB Status",
                              value: ibStatus.toUpperCase(),
                              iconClass: "bx-user-plus",
                              iconBgClass: "bg-warning"
                            }
                          ]}
                          tableClassName="table align-middle table-sm mb-0"
                          disablePagination={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-xxl-8 col-xl-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">IB Analytics</h4>
                      <div
                        id="line_chart_datalabel"
                        data-colors='["--bs-primary", "--bs-success"]'
                        className="apex-charts"
                        dir="ltr"
                      />
                      <IbChart />
                    </div>
                  </div>
                 
                </div> */}
                <div className="col-xl-5">
                  {/* <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">IB Affiliate Details</h4>
                      <div className="table-responsive theme-scrollbar text-nowrap">
                        <table className="table ib_dash_table display">
                          <thead>
                            <tr>
                              <th>Files Name</th>
                              <th>Amount</th>
                              <th>% Sold</th>
                              <th>Progressbar</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Touch sensor Lamp</td>
                              <td> $ 7.938</td>
                              <td> 52.93%</td>
                              <td>
                                <div className="progress progress-striped-primary b-r-2">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: "70%" }}
                                    aria-valuenow={10}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Bluetooth headphone</td>
                              <td> $ 2.937</td>
                              <td> 12.52%</td>
                              <td>
                                <div className="progress progress-striped-secondary b-r-2">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: "40%" }}
                                    aria-valuenow={10}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Apple watch series 8</td>
                              <td> $ 1.923</td>
                              <td> 84.12%</td>
                              <td>
                                <div className="progress progress-striped-warning b-r-2">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: "60%" }}
                                    aria-valuenow={10}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Macbook Pro M1</td>
                              <td> $ 5.538</td>
                              <td> 01.41%</td>
                              <td>
                                <div className="progress progress-striped-tertiary b-r-2">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: "80%" }}
                                    aria-valuenow={10}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>iphone 12 Pro max</td>
                              <td> $ 8.258</td>
                              <td> 14.34%</td>
                              <td>
                                <div className="progress progress-striped-primary b-r-2">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: "50%" }}
                                    aria-valuenow={10}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>iphone 12 Pro max</td>
                              <td> $ 8.258</td>
                              <td> 14.34%</td>
                              <td>
                                <div className="progress progress-striped-primary b-r-2">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: "50%" }}
                                    aria-valuenow={10}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-xxl-8 col-xl-12 col-lg-12">
                  {/* <div className="card">
                    <div className="card-body p-4">
                      <table
                        ref={tableRef}
                        id="datatable-buttons"
                        className="table table-bordered dt-responsive table-striped nowrap w-100"
                      >
                        <thead>
                          <tr>
                            <th>Ticket No</th>
                            <th>Subject</th>
                            <th>Priority</th>
                            <th>Department</th>
                            <th>Created Date</th>
                            <th>Closed Date</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Deposit</td>
                            <td className="notranslate" translate="no">Tether USD (USDT TRC20)</td>
                            <td>91020</td>
                            <td>100.00</td>
                            <td>USD</td>
                            <td>2024-08-20</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-soft-success waves-effect waves-light"
                              >
                                Completed
                              </button>
                            </td>
                            <td>
                              <ul className="list-unstyled hstack gap-1 mb-0">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="View"
                                >
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-soft-primary"
                                  >
                                    <i className="mdi mdi-eye-outline fs-5" />
                                  </button>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Delete"
                                >
                                  <button className="btn btn-sm btn-soft-danger">
                                    <i className="mdi mdi-delete-outline fs-5" />
                                  </button>
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>Deposit</td>
                            <td className="notranslate" translate="no">Tether USD (USDT TRC20)</td>
                            <td>91020</td>
                            <td>100.00</td>
                            <td>USD</td>
                            <td>2024-08-20</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-soft-success waves-effect waves-light"
                              >
                                Completed
                              </button>
                            </td>
                            <td>
                              <ul className="list-unstyled hstack gap-1 mb-0">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="View"
                                >
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-soft-primary"
                                  >
                                    <i className="mdi mdi-eye-outline fs-5" />
                                  </button>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Delete"
                                >
                                  <button className="btn btn-sm btn-soft-danger">
                                    <i className="mdi mdi-delete-outline fs-5" />
                                  </button>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> */}
                </div>
                <div className="col-xl-6 col-lg-12">
                  {/* <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">Performance Analytics</h4>
                      <div className="table-responsive theme-scrollbar">
                        <table className="table ib_dash_table display">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Started</th>
                              <th>Finsihed</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <h6 className="mb-0">Behance Post</h6>
                                </div>
                              </td>
                              <td>05Jan23</td>
                              <td className="f-w-600 text-dark">12Jan23 </td>
                              <td className="text-warning-dark f-w-600">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-soft-primary"
                                >
                                  <i className="mdi mdi-eye-outline fs-5"></i>
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">Figma Design</h6>
                              </td>
                              <td>11Feb23</td>
                              <td className="f-w-600 text-dark">23Feb23</td>
                              <td className="text-warning-dark f-w-600">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-soft-primary"
                                >
                                  <i className="mdi mdi-eye-outline fs-5"></i>
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">Web Page</h6>
                              </td>
                              <td>17Mar23</td>
                              <td className="f-w-600 text-dark">27Mar23</td>
                              <td className="text-warning-dark f-w-600">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-soft-primary"
                                >
                                  <i className="mdi mdi-eye-outline fs-5"></i>
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">CRM Admin</h6>
                              </td>
                              <td>05Sep23</td>
                              <td className="f-w-600 text-dark">15Sep23</td>
                              <td className="text-warning-dark f-w-600">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-soft-primary"
                                >
                                  <i className="mdi mdi-eye-outline fs-5"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-xl-6 col-lg-12">
                  {/* <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">IB Team Performance</h4>
                      <div className="table-responsive ib_perfomance_table theme-scrollbar">
                        <table className="table ib_dash_table  display">
                          <thead>
                            <tr>
                              <th>Product</th>
                              <th>Units Sold</th>
                              <th>Sales</th>
                              <th>Rating</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <h6 className="mb-0">Wireless Headphones</h6>
                                </div>
                              </td>
                              <td>250</td>
                              <td className="f-w-600 text-dark">$5,000</td>
                              <td className="text-warning-dark f-w-600">
                                <i className="iconoir-star-solid text-warning me-1"></i>
                                4.8
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">Smartwatch</h6>
                              </td>
                              <td>210</td>
                              <td className="f-w-600 text-dark">$5,000</td>
                              <td className="text-warning-dark f-w-600">
                                <i className="iconoir-star-solid text-warning me-1"></i>
                                4
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">Bluetooth Speaker</h6>
                              </td>
                              <td>190</td>
                              <td className="f-w-600 text-dark">$4,200</td>
                              <td className="text-warning-dark f-w-600">
                                <i className="iconoir-star-solid text-warning me-1"></i>
                                4.5
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">4K Ultra HD TV</h6>
                              </td>
                              <td>175</td>
                              <td className="f-w-600 text-dark">$3,800</td>
                              <td className="text-warning-dark f-w-600">
                                <i className="iconoir-star-solid text-warning me-1"></i>
                                4.9
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">4K Ultra HD TV</h6>
                              </td>
                              <td>175</td>
                              <td className="f-w-600 text-dark">$3,800</td>
                              <td className="text-warning-dark f-w-600">
                                <i className="iconoir-star-solid text-warning me-1"></i>
                                4.9
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h6 className="mb-0">4K Ultra HD TV</h6>
                              </td>
                              <td>175</td>
                              <td className="f-w-600 text-dark">$3,800</td>
                              <td className="text-warning-dark f-w-600">
                                <i className="iconoir-star-solid text-warning me-1"></i>
                                4.9
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            {/* container-fluid */}
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
